<template>
  <el-submenu
    :index="String('menu_' + item.arme_id + $randomNumber())"
    :key="'menu_' + item.arme_id + $randomNumber()"
  >
    <template #title>
      <el-tooltip
        v-if="arpe_id == 1"
        class="item"
        effect="light"
        content="Si está seleccionado, el administrador podrá asignar esta opción a sus usuarios."
        placement="left-start"
      >
        <el-checkbox
          v-model="item.arme_estado"
          :true-label="1"
          :false-label="0"
          @change="handleItemChangeStatus"
        ></el-checkbox>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        content="Si está seleccionado, el usuario podrá ver esta opción en el menú."
        placement="left-start"
      >
        <el-checkbox
          v-model="item.selected"
          @change="handleItemChange"
        ></el-checkbox>
      </el-tooltip>
      <small>
        {{ item.arme_nombre }}
      </small>
    </template>

    <template v-for="child in item.children">
      <template v-if="isSubMenu(child)">
        <RecursiveSubmenu
          :item="child"
          :key="'menu_' + child.arme_id + $randomNumber()"
          :is-sub-menu="isSubMenu"
          @item-selected="handleSelected"
          @item-selected-status="handleItemStatus"
        ></RecursiveSubmenu>
      </template>
      <template v-else>
        <RecursiveMenuItem
          :item="child"
          :key="'menu_' + child.arme_id + $randomNumber()"
          @item-selected="handleSelected"
          @item-selected-status="handleItemStatus"
        ></RecursiveMenuItem>
      </template>
    </template>
  </el-submenu>
</template>

<script>
  import RecursiveMenuItem from './RecursiveMenuItem'
  export default {
    name: 'RecursiveSubmenu',
    components: {
      RecursiveMenuItem
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      isSubMenu: {
        type: Function,
        required: true
      }
    },
    data() {
      return {
        arpe_id: localStorage.getItem('profile')
      }
    },
    methods: {
      handleItemStatus() {
        const hasSelectedChild = this.item.children.some(
          child => child.arme_estado
        )
        if (hasSelectedChild) {
          this.item.arme_estado = 1
        } else {
          this.item.arme_estado = 0
        }
        this.$emit('item-selected-status', this.item)
      },

      handleItemChangeStatus() {
        this.toggleStatusChildren(this.item, this.item.arme_estado)
        this.$emit('item-selected-status', this.item)
      },

      toggleStatusChildren(node, status) {
        node.arme_estado = status
        if (node.children && node.children.length > 0) {
          node.children.forEach(child => {
            this.toggleStatusChildren(child, status)
          })
        }
      },

      handleSelected() {
        const hasSelectedChild = this.item.children.some(
          child => child.selected
        )
        if (hasSelectedChild) {
          this.item.selected = true
        } else {
          this.item.selected = false
        }
        this.$emit('item-selected', this.item)
      },

      handleItemChange() {
        this.toggleChildren(this.item, this.item.selected)
        this.$emit('item-selected', this.item)
      },

      toggleChildren(node, selected) {
        node.selected = selected
        if (node.children && node.children.length > 0) {
          node.children.forEach(child => {
            this.toggleChildren(child, selected)
          })
        }
      }
    }
  }
</script>
